import { render, staticRenderFns } from "./component.vue?vue&type=template&id=c15c05e6&scoped=true&lang=pug"
import script from "./component.vue?vue&type=script&lang=js"
export * from "./component.vue?vue&type=script&lang=js"
import style0 from "./component.vue?vue&type=style&index=0&id=c15c05e6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c15c05e6",
  null
  
)

/* custom blocks */
import block0 from "./locale.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Fc-auth%2Fform-registration%2Fcomponent.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports